export const resetExternalError = (
  fieldName: string,
  v$: any,
  $externalResults: any
) => {
  const field = $externalResults.value[fieldName]

  if (Array.isArray(field)) {
    resetValidation(v$, fieldName)
    resetExternalResults($externalResults, fieldName)
  }

  return { v$, $externalResults }
}

const resetValidation = (v$: any, fieldName: string) => {
  v$.value[fieldName].$reset()

  return v$
}

const resetExternalResults = ($externalResults: any, fieldName: string) => {
  if (fieldName in $externalResults.value) {
    $externalResults.value[fieldName] = undefined
  }

  return $externalResults
}
